const LocationsEndpoint = {
  new(form) {
    return {
      url: '/locations',
      method: 'POST',
      body: JSON.stringify(form)
    }
  },
  delete(id) {
    return {
      url: `/locations/${id}`,
      method: 'DELETE',
    }
  }

}

export default LocationsEndpoint



// WEBPACK FOOTER //
// ./src/persistence/LocationEndpoint.js